import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flow } from 'signup-constants/Flow';
import styled from 'styled-components';
import { H1 } from 'UIComponents/elements/headings';
import { getFlowKey } from '../routing/getFlowKey';
import { isSoftwareSignup } from '../store/flow/selectors';
import { devices } from '../styles/viewports.styles';
import { getIntegrationName } from '../utils/getIntegrationName';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { Step } from '../views/Step';
import { getLandingPageTitle } from './getLandingPageText';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { StepSubtitle } from '../views-components/StepSubtitle';
export const StyledH1 = styled(H1).withConfig({
  displayName: "LandingPageTitle__StyledH1",
  componentId: "rshrji-0"
})(["font-size:2.25rem;", " ", " @media ", "{margin-top:40px;", "}@media ", "{margin-top:", ";}"], props => (props.flowKey === Flow.Connect || props.flowKey === Flow.ChatSpot) && `font-size: 1.75rem;`, props => props.theme.embedded && ` margin-top: 0;
      font-size: 1.75rem;`, devices.tablet, props => props.isFramedCentredStep && ` margin-top: 0;`, devices.desktop, props => props.isFramedCentredStep ? '20px' : '0');
export const LandingPageSubtitle = styled.div.withConfig({
  displayName: "LandingPageTitle__LandingPageSubtitle",
  componentId: "rshrji-1"
})(["", ""], props => props.theme.embedded && `margin-bottom: 1rem;`);
export const LandingPageTitle = ({
  isMobile,
  isFramedCentredStep = false
}) => {
  const flowKey = getFlowKey();
  const {
    title,
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const {
    isAssignedToSpecificVariant
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);
  const defaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
  const subtitle = isMobile && isSoftwareSignup() ? defaultMobileSubtitle : subtitleLabel;
  const shouldShowSubtitle = !isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B);
  const mainTitle = isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B) ? `views.${Step.LandingPage}.title.acq134.variant_b` : title;
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center m-x-auto flex-column justify-center",
    children: [isAssignedToSpecificVariant(ExperimentParameterGroup.Variant_B) && /*#__PURE__*/_jsx(StepSubtitle, {
      message: `views.${Step.LandingPage}.preTitle.acq134.variant_b`
    }), /*#__PURE__*/_jsx(StyledH1, {
      flowKey: flowKey,
      isFramedCentredStep: isFramedCentredStep,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: mainTitle,
        options: {
          integratorName: getIntegrationName()
        }
      })
    }), shouldShowSubtitle && /*#__PURE__*/_jsx(LandingPageSubtitle, {
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: subtitle
      })
    })]
  });
};